<template lang="pug">
#visualizar-monitoramento-agricola(
    v-if='monitoramento && dadosMonitoramentoAgro'
)
    BaseHeader(
        :titulo='territorio.nome',
        :exibeBotao='false',
        :voltarPara='voltarPara',
        icon='mdi mdi-file-download ',
        :btnTexto='$t("mensagens.monitoramentoAgricola.visualizarImovel.baseHeader.botao")'
    )
    //- VAI SER IMPLANTADO NO FUTURO
    //- .paddingCondicional
    //-     el-switch.posicao-condicional.toggle(
    //-         v-model='abaAtual',
    //-         :active-text='$t("mensagens.monitoramentoAgricola.visualizarImovel.switch.ativo")',
    //-         :inactive-text='$t("mensagens.monitoramentoAgricola.visualizarImovel.switch.inativo")',
    //-         active-color='#a6ce39',
    //-         inactive-color='#a6ce39'
    //-     )
    .view-container.bloco-dataSecao(v-if='abaAtual')
        Historico(
            :dadosAreaMonitorada='monitoramento',
            :altura='90',
            :isHorizontal='true'
        )
    .view-container.bloco-dataSecao(v-if='!abaAtual')
        BlocoAlertaVisualizarMonitoramentoAgricola(
            :codigoAreaMonitorada='monitoramento.codigoVegaAPI'
        )
        .bloco-dataSecao--container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoDataAcao.titulo') }}
            .bloco-dataSecao--container--interno--info
                BlocoDataAcaoMonitoramentoAgricola.bloco-info(
                    :titulo='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoDataAcao.ultimaVisita")',
                    :valor='dadosPlantio.ultimaVisita ? dadosPlantio.ultimaVisita.dataVisita : "-"'
                )
                BlocoDataAcaoMonitoramentoAgricola.bloco-info(
                    :titulo='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoDataAcao.dadosDeReferencia")',
                    :valor='dadosPlantio.ultimaVisita ? dadosPlantio.ultimaVisita.dataImagem : "-"'
                )

        .bloco-dataSecao--container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.titulo') }}
            .bloco-dataSecao--container--interno
                BlocoAreaPlantadaProdutividadeMonitoramentoAgricola(
                    :titulo='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.areaPlantada")',
                    subtitulo='Análise de área (ha):',
                    :valorInformado='dadosAreasPlantadas.informada',
                    :valorMonitorado='dadosAreasPlantadas.monitorada',
                    :exibir-valor-divergente='false',
                    :divergencia='dadosAreasPlantadas.divergencia',
                    :iconeDivergencia='dadosAreasPlantadas.divergencia ? "mdi mdi-alert-outline" : "mdi mdi-check-circle-outline"'
                )
                BlocoSituacaoMonitoramentoAgricola(
                    icone='mdi mdi-calendar-month',
                    :titulo='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.dataPlantio")',
                    :descricaoEsquerda='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.dataInformada")',
                    :valorEsquerdo='dadosDataPlantio.informada',
                    :descricaoDireita='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.dataIdentificada")',
                    :valorDireito='dadosDataPlantio.monitorada',
                    :iconeDivergencia='dadosDataPlantio.divergencia ? "mdi mdi-alert-outline" : "mdi mdi-check-circle-outline"',
                    :divergencia='dadosDataPlantio.divergencia'
                )
                BlocoSituacaoMonitoramentoAgricola(
                    icone='lyra-icon lyra-planta',
                    :titulo='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.cultura")',
                    :descricaoEsquerda='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.culturaInformada")',
                    :valorEsquerdo='dadosCultura.informada',
                    :descricaoDireita='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.culturaMonitorada")',
                    :valorDireito='dadosCultura.monitorada',
                    :desabilitar='dadosCultura.monitorada === "-"',
                    :iconeDivergencia='dadosCultura.divergencia ? "mdi mdi-alert-outline" : dadosCultura.monitorada === "-" ? "" : "mdi mdi-check-circle-outline"',
                    :divergencia='dadosCultura.divergencia'
                )
                BlocoAreaPlantadaProdutividadeMonitoramentoAgricola(
                    :titulo='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.produtividade")',
                    :subtitulo='produtividade.titulo',
                    :valorInformado='produtividade.informada',
                    :valorMonitorado='produtividade.monitorada',
                    :valorDivergente='produtividade.percentualDivergencia',
                    :divergencia='produtividade.divergencia',
                    :desabilitar='produtividade.percentualDivergencia === "-"',
                    :iconeDivergencia='produtividade.divergencia ? "mdi mdi-alert-outline" : produtividade.monitorada === "-" ? "" : "mdi mdi-check-circle-outline"',
                    :exibir-paginacao='paginacao',
                    :pagina-atual='produtividade.index + 1',
                    :pagina-final='dadosProdutividade.length',
                    @pagina-anterior='paginaAnterior',
                    @pagina-seguinte='paginaSeguinte'
                )

        .dados-territorio-monitoramento__container
            .dados-territorio-monitoramento-dados
                .dados-territorio-monitoramento-dados-item
                    h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.dadosTerritorio') }}
                    BlocoDadosTerritorioMonitoramentoAgricola(
                        :monitoramento='monitoramento'
                    )
                .dados-territorio-monitoramento-dados-item
                    h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.carsVinculados') }}
                    BlocoDadosCarVinculadosMonitoramentoAgricola(
                        :cars='monitoramento.carsApi',
                        :monitoramento='monitoramento'
                    )
                .dados-territorio-monitoramento-dados-item(v-show='false')
                    h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.informacoesAdicionais') }}
                    BlocoInformacoesAdicionaisMonitoramento(
                        :operacoes='operacoes'
                    )

        .carrosel-clima__container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.previsaoClimatica') }}
            CarroselClimaMonitoramentoAgricola

        .tabs_mapa__container
            h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.selecioneCulturaParaVisualizarDadosMonitoramento') }}
            BlocoTabsMapaMonitoramentoAgricola(
                :monitoramento='monitoramento',
                :monitoramentoAgro='dadosMonitoramentoAgro',
                :dadosPlantio='dadosPlantio'
            )

        .bloco-ndvi
            el-row.info-selecao-grafico
                h3.info-selecao-texto {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.tituloGrafico') }}
                el-select(
                    v-if='culturaAtual === "SOJA"',
                    v-model='codigoAcuracia',
                    placeholder='Selecione a Acurácia Desejada',
                    style='width: 240px'
                )
                    el-option(
                        v-for='item in listaAcuracias',
                        :key='item.value',
                        :label='item.label',
                        :value='item.codigo'
                    )
                        div(
                            :style='{ display: "flex", "align-items": "center" }'
                        )
                            div(
                                :style='{ "background-color": item.value, "margin-right": "10px", width: "20px", height: "20px", "border-radius": "3px" }',
                                size='small',
                                :round=false
                            )
                            span(:style='{ "margin-top": "4px" }') {{ item.label }}

            card(
                :info='$t("mensagens.monitoramentoAgricola.visualizarImovel.blocoNdvi.infoGrafico")'
            )
                grafico-evolucao-indice-vegetacao(
                    :dadosMonitoramentoNDVI='dadosAcuraciaSelecionada',
                    v-if='dadosMonitoramentoAgro'
                )

        .bloco-historico-monitoramento(style='display: none')
            .bloco-historico-monitoramento__historico
                .bloco-historico-monitoramento__header
                    .bloco-historico-monitoramento__titulo
                        h3 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoHistoricoMonitoramento.titulo') }}
                        h4 {{ $t('mensagens.monitoramentoAgricola.visualizarImovel.blocoHistoricoMonitoramento.subtitulo') }}
                .bloco-historico-monitoramento__lista
                    TimelineHistoricoMonitoramento(
                        :dados='historicosMonitoramento'
                    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoAlertaVisualizarMonitoramentoAgricola from '@/components/monitoramento/BlocoAlertaVisualizarMonitoramentoAgricola';
import BlocoDataAcaoMonitoramentoAgricola from '@/components/monitoramento/BlocoDataAcaoMonitoramentoAgricola';
import BlocoSituacaoMonitoramentoAgricola from '@/components/monitoramento/BlocoSituacaoMonitoramentoAgricola';
import BlocoAreaPlantadaProdutividadeMonitoramentoAgricola from '@/components/monitoramento/BlocoAreaPlantadaProdutividadeMonitoramentoAgricola';
import BlocoDadosTerritorioMonitoramentoAgricola from '@/components/monitoramento/BlocoDadosTerritorioMonitoramentoAgricola';
import BlocoInformacoesAdicionaisMonitoramento from '@/components/monitoramento/BlocoInformacoesAdicionaisMonitoramento';
import CarroselClimaMonitoramentoAgricola from '@/components/monitoramento/CarroselClimaMonitoramentoAgricola';
import BlocoTabsMapaMonitoramentoAgricola from '@/components/monitoramento/BlocoTabsMapaMonitoramentoAgricola';
import TimelineHistoricoMonitoramento from '@/components/monitoramento/TimelineHistoricoMonitoramento';
import Historico from '@/components/areamonitorada/Historico';
import BlocoDadosCarVinculadosMonitoramentoAgricola from '@/components/monitoramento/BlocoDadosCarVinculadosMonitoramentoAgricola';
import GraficoEvolucaoIndiceVegetacao from '@/components/areamonitorada/graficos/GraficoEvolucaoIndiceVegetacao';
import Card from '@/components/Card';

import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import MonitoramentoService from '@/services/MonitoramentoService';
import HistoricoService from '@/services/HistoricoService';
import TipoMonitoramento from '@/constants/TipoMonitoramento';
import EventBus from '@/utils/eventBus';

export default {
    name: 'VisualizarMonitoramentoAgricolaImovel',
    components: {
        BaseHeader,
        BlocoAlertaVisualizarMonitoramentoAgricola,
        BlocoDataAcaoMonitoramentoAgricola,
        BlocoSituacaoMonitoramentoAgricola,
        BlocoAreaPlantadaProdutividadeMonitoramentoAgricola,
        BlocoDadosTerritorioMonitoramentoAgricola,
        BlocoInformacoesAdicionaisMonitoramento,
        CarroselClimaMonitoramentoAgricola,
        BlocoTabsMapaMonitoramentoAgricola,
        TimelineHistoricoMonitoramento,
        Historico,
        BlocoDadosCarVinculadosMonitoramentoAgricola,
        GraficoEvolucaoIndiceVegetacao,
        Card
    },
    data() {
        return {
            paginacao: false,
            produtividade: {
                index: 0,
                informada: '-',
                monitorada: '-',
                percentualDivergencia: '-',
                divergencia: false,
                titulo: this.$t(
                    'mensagens.monitoramentoAgricola.visualizarImovel.blocoSituacaoMonitoramento.analiseProducao'
                ),
                cultura: '-'
            },
            operacoes: ['OP1', 'OP 2', 'oPE 3'],
            voltarPara: {
                route: 'MonitoramentoAgricola'
            },
            idAreaMonitorada: this.$route.params.id,
            monitoramento: null,
            territorio: null,
            dadosMonitoramentoAgro: null,
            historicosMonitoramento: [],
            dadosPlantioCarregados: false,
            dadosPlantio: {
                areasPlantadas: [],
                dataConsulta: '-',
                dataUltimoProcessamento: '-',
                ultimaVisita: '-'
            },
            dadosDataPlantio: {
                informada: '-',
                monitorada: '-',
                divergencia: false
            },
            dadosCultura: {
                informada: '-',
                monitorada: '-',
                divergencia: false
            },
            dadosAreasPlantadas: {
                informada: '-',
                monitorada: '-',
                divergencia: false
            },
            dadosProdutividade: [],
            abaAtual: false,
            culturaAtual: '',
            dadosAcuraciaSelecionada: [],
            codigoAcuracia: '',
            listaAcuracias: [
                {
                    value: '#63AF01',
                    label: 'Maior que 80%',
                    codigo: 'MAIOR_80'
                },
                {
                    value: '#889306',
                    label: 'Entre 51% e 80%',
                    codigo: 'DE_51_A_80'
                },
                {
                    value: '#D6D951',
                    label: 'Menor que 50%',
                    codigo: 'MENOR_50'
                }
            ],
            dadosGraficoSojaMaior80: [],
            dadosGraficoSoja50e80: [],
            dadosGraficoSojaMenor50: []
        };
    },
    async mounted() {
        EventBus.$on(
            'emit-change-cultura',
            async (listaCodigosAcuracia, culturaSelecionada) => {
                this.codigoAcuracia = '';
                this.culturaAtual = culturaSelecionada;
                await this.fetchDadosGraficoNdvi(listaCodigosAcuracia);
            }
        );
        await this.fetchAreaMonitorada();
        await this.fetchDadosPlantio();
        await this.fetchDadosMonitoramento();
        await this.buscarMonitoramento();
        this.exibirPaginacao();
    },
    watch: {
        codigoAcuracia() {
            this.dadosAcuraciaSelecionada = [];
            if (this.codigoAcuracia === 'MAIOR_80') {
                this.dadosAcuraciaSelecionada = this.dadosGraficoSojaMaior80;
            } else if (this.codigoAcuracia === 'DE_51_A_80') {
                this.dadosAcuraciaSelecionada = this.dadosGraficoSoja50e80;
            } else if (this.codigoAcuracia === 'MENOR_50') {
                this.dadosAcuraciaSelecionada = this.dadosGraficoSojaMenor50;
            }
        },
        monitoramento() {
            if (
                this.monitoramento &&
                this.dadosMonitoramentoAgro &&
                this.dadosPlantioCarregados
            ) {
                this.montarDados();
            }
        },
        dadosMonitoramentoAgro() {
            if (
                this.monitoramento &&
                this.dadosMonitoramentoAgro &&
                this.dadosPlantioCarregados
            ) {
                this.montarDados();
            }
        },
        dadosPlantioCarregados() {
            if (
                this.monitoramento &&
                this.dadosMonitoramentoAgro &&
                this.dadosPlantioCarregados
            ) {
                this.montarDados();
            }
        }
    },
    methods: {
        exibirPaginacao() {
            this.paginacao = this.dadosProdutividade.length > 1;
            this.produtividade = this.dadosProdutividade[0];
            this.produtividade.index = 0;
        },
        paginaSeguinte() {
            let quantidadeDeProdutividade = this.dadosProdutividade.length - 1;
            let indexAtual = this.produtividade.index;
            if (this.produtividade.index < quantidadeDeProdutividade) {
                let indexSeguinte = indexAtual + 1;
                this.produtividade = this.dadosProdutividade[indexSeguinte];
                this.produtividade.index = indexSeguinte;
            }
        },
        paginaAnterior() {
            let indexAtual = this.produtividade.index;
            let indexDoMeio = 1;
            if (this.produtividade.index >= indexDoMeio) {
                let indexAnterior = indexAtual - indexDoMeio;
                this.produtividade = this.dadosProdutividade[indexAnterior];
                this.produtividade.index = indexAnterior;
            }
        },
        async buscarMonitoramento() {
            try {
                const { data } =
                    await MonitoramentoAgricolaService.buscarSituacaoAreaMonitoradaPorId(
                        this.idAreaMonitorada
                    );
                this.dadosDataPlantio = data.dadosPlantio;
                this.dadosCultura = data.cultura;
                this.dadosAreasPlantadas = data.areaPlantada;
                this.dadosProdutividade = data.produtividades;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.buscarMonitoramento'
                    )
                });
            }
        },
        async fetchAreaMonitorada() {
            try {
                const { data } =
                    await MonitoramentoAgricolaService.buscarAreaMonitoradaPorId(
                        this.idAreaMonitorada
                    );
                this.monitoramento = data;
                this.territorio = data.territorio;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.buscarMonitoramento'
                    )
                });
            }
        },
        async fetchDadosPlantio() {
            try {
                const { data } = await MonitoramentoService.dadosPlantio(
                    this.idAreaMonitorada
                );
                this.dadosPlantio = data;
                this.dadosPlantioCarregados = true;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.fetchDadosPlantio'
                    )
                });
            }
        },
        async fetchDadosGraficoNdvi(listaCodigosAcuracia) {
            try {
                this.dadosAcuraciaSelecionada = [];
                const { data } =
                    await MonitoramentoAgricolaService.atualizaGraficoNdvi(
                        this.idAreaMonitorada,
                        listaCodigosAcuracia
                    );
                this.dadosMonitoramentoAgro.monitoramentoNDVI = data;

                if (
                    listaCodigosAcuracia.includes('MENOR_50') ||
                    listaCodigosAcuracia.includes('DE_51_A_80') ||
                    listaCodigosAcuracia.includes('MAIOR_80')
                ) {
                    data.map(item => {
                        if (
                            ['MENOR_50', 'DE_51_A_80', 'MAIOR_80'].includes(
                                item.codigoAcuracia
                            )
                        ) {
                            if (item.codigoAcuracia === 'MENOR_50') {
                                this.dadosGraficoSojaMenor50.push(item);
                            }
                            if (item.codigoAcuracia === 'DE_51_A_80') {
                                this.dadosGraficoSoja50e80.push(item);
                            }
                            if (item.codigoAcuracia === 'MAIOR_80') {
                                let obj = {
                                    codigoAcuracia: item.codigoAcuracia,
                                    dataProcessamento: item.dataProcessamento,
                                    ndviPercentual: item.ndviPercentual
                                };
                                this.dadosGraficoSojaMaior80.push(obj);
                            }
                        }
                    });
                } else {
                    this.dadosAcuraciaSelecionada = data;
                }
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.fetchDadosGraficoNdvi'
                    )
                });
            }
        },
        async fetchDadosMonitoramento() {
            try {
                const { data } = await MonitoramentoService.monitoramentoAgro(
                    this.idAreaMonitorada
                );
                this.dadosMonitoramentoAgro = data;
            } catch (e) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.fetchDadosMonitoramento'
                    )
                });
            }
        },
        async fetchHistoricosMonitoramento() {
            try {
                const { data } =
                    await HistoricoService.buscarHistoricoMonitoramentoPorAreaMonitoradaId(
                        this.idAreaMonitorada
                    );

                data.forEach(historico => {
                    this.historicosMonitoramento.push({
                        ...historico,
                        tipoMonitoramento: TipoMonitoramento.AGRICOLA,
                        territorio: this.territorio,
                        color: historico.possuiRestricao
                            ? 'var(--warning)'
                            : '#09413C'
                    });
                });
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.monitoramentoAgricola.erros.buscarMonitoramento'
                    )
                });
            }
        },
        async montarDados() {
            await this.buscarMonitoramento();
            await this.fetchHistoricosMonitoramento();
        }
    }
};
</script>

<style lang="scss" scoped>
#visualizar-monitoramento-agricola {
    .bloco-dataSecao {
        margin-top: 20px;
        margin-bottom: 20px;
        .bloco-dataSecao--container {
            margin-top: 20px;
        }
        .bloco-dataSecao--container--interno {
            display: flex;
            justify-content: space-between;
            margin-top: 7px;
        }
        .bloco-dataSecao--container--interno--info {
            display: flex;
            justify-content: space-between;
            margin-top: 7px;
        }
        .bloco-info {
            width: 49%;
        }
    }

    .dados-territorio-monitoramento__container {
        margin: 18px 5px 10px 5px;

        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
        }
        .dados-territorio-monitoramento-dados {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            .dados-territorio-monitoramento-dados-item {
                max-height: 272px;
                width: 49.25%;

                &:last-child {
                    margin: 2px 0px;
                }
            }
        }
    }
    .carrosel-clima__container,
    .tabs_mapa__container {
        margin-top: 18px;

        h3 {
            margin-bottom: 13px;
            margin-top: 10px;
            color: var(--black);
        }
    }

    .bloco-ndvi {
        margin-top: 30px;

        h3 {
            margin-bottom: 13px;
            margin-top: 10px;
            color: var(--black);
        }
    }

    .bloco-historico-monitoramento {
        display: flex;
        margin-top: 25px;
        .bloco-historico-monitoramento__historico {
            width: 100%;
            padding: 0px 10px 0px 0px;
            .bloco-historico-monitoramento__header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .bloco-historico-monitoramento__icone {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    width: 24px;
                    height: 25px;
                    background-color: var(--white);
                    padding: 17px;
                    border-radius: 5px;
                    box-shadow: 0px 1px 4px rgb(187 187 187);
                }
            }
            .bloco-historico-monitoramento__lista {
                background: var(--white);
                margin: 2px 3px 2px 2px;
                box-shadow: 0px 0px 2px 0px var(--block-shadow);
                border-radius: 5px;
                border: 1px solid var(--default-border-color);
                overflow-y: auto;
                height: 445px;
            }
        }

        h3 {
            margin-bottom: 0px;
            color: var(--black);
            font-weight: 500;
        }
    }

    .paddingCondicional {
        padding-top: 28px;
    }

    .posicao-condicional {
        display: flex;
        justify-content: center;
    }

    .info-selecao-grafico {
        display: flex;
        align-items: center;
    }

    .info-selecao-texto {
        margin-right: 20px;
    }
}
@media only screen and (max-width: 1351px) {
    .dados-gerais-monitoramento__lista h3 {
        min-width: 49.25% !important;
    }
}
</style>
